import { Component, OnInit, AfterViewInit} from '@angular/core';
import {Router} from '@angular/router';

import * as $ from 'jquery';

@Component({
  selector: 'app-header-mainindex',
  templateUrl: './header-mainindex.component.html',
  styleUrls: ['./header-mainindex.component.css']
})
export class HeaderMainindexComponent implements OnInit, AfterViewInit {

  constructor(private router: Router) {}

  ngOnInit(): void {
    // $(document).ready(() => {
    //   $.getScript('../assets/js/mmenu.js');
    //   $.getScript('../assets/js/custom.js');
    // });
  }

  ngAfterViewInit(): void{

  }




  public goToIndex(){
    this.router.navigateByUrl('/index', { skipLocationChange: true }).then(() => {
      // this.router.navigate(['Your actualComponent']);
      // this.router.navigate(['mainindex']);
      this.router.navigate(['index']);
    });
    // this.router.navigate(['../index']).then(() => window.location.reload());
  }
}
